import React from 'react';
import GoalForm from './GoalForm';
import GoalShow from './GoalShow';

const CreateGoalHome = () => {
    return (
        <div>
            <GoalForm />
            <GoalShow />
        </div>
    );
};

export default CreateGoalHome;